var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-tile-content"},[_c('video',{ref:"video",attrs:{"autoplay":"","playsinline":"","muted":"","controls":""},domProps:{"muted":true}}),_c('audio',{ref:"audio",attrs:{"autoplay":"","muted":_vm.muted}})])}
var staticRenderFns = []

export { render, staticRenderFns }